"use client";

import { Button } from "@/components/Button";
import { FormattedText } from "@/components/FormattedText";
import { Routes } from "@/lib/routes";
import { useRouter } from "next/navigation";
import styles from "./not-found.module.css";

export default function NotFound() {
  const router = useRouter();

  return (
    <main className={styles["not-found"]}>
      <h1>404</h1>
      <FormattedText>
        <p>Такой страницы не существует</p>
      </FormattedText>
      <Button onClick={() => router.push(Routes.MAIN)} variant={"primary"}>
        Вернуться
      </Button>
    </main>
  );
}
